<template>
	<div class="section3">
		<div class="sub-title">{{ $t('策略广场') }}</div>

		<ul>
			<li class="item" v-for="item in list" :key="item.id">
				<div class="top">
					<div class="top-row">
						<img v-for="value in item.product_list" :key="value.id" :src="value.image" class="lazy-img">
						<span class="name">{{ item.invest }}</span>
						<span class="title">{{ item.type }}{{ $t('预测') }}</span>
					</div>
					<img :src="item.image_bg" class="dsddad">
				</div>
				<div class="middle">
					<div class="column">
						<span class="area">
							<span>{{ $t('最大收益率') }}</span>
							<span class="win">{{ item.rate }}%</span>
						</span>
						<span class="area">
							<span>{{ $t('投入金额') }}</span>
							<span>&gt;{{ item.amount }}</span>
						</span>
					</div>
					<div class="column bl">
						<span class="area">
							<span>{{ $t('最大回撤率') }}</span>
							<span class="win">{{ item.ratemax }}%</span>
						</span>
						<span class="area">
							<span>{{ $t('运行时长') }}</span>
							<span>{{ item.days }}d</span>
						</span>
					</div>
				</div>
				<div class="bottom">
					<span class="span1">{{ item.name }}</span>
					<span class="span2"></span>
					<div class="but" @click="$emit('openSubmit', item.id)">
						{{ $t('使用本策略') }}
					</div>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	components: {},
	props: {
		list: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {};
	},
	methods: {

	},
};
</script>
<style lang="scss" scoped>
.section3 {
	min-height: 630px;
	max-height: 905px;
	border-radius: 12px;
	border: 2Px solid #252731;
	background: #12141e;
	overflow-y: auto;

	.sub-title {
		width: 90%;
		margin: 30px auto;
		font-size: 22px;
	}

	ul {
		display: flex;
		flex-direction: row;
		align-items: normal;
		justify-content: normal;
		max-height: 800px;
		overflow-y: auto;
		padding: 0 45px;
		flex-wrap: wrap;
		list-style: none;

		li {
			width: calc(33.33% - 16px);
			padding: 10px;
			background-color: #0b0b0d;
			position: relative;
			margin-bottom: 16px;
			margin-right: 16px;
			border-radius: 8px;
		}

		.bottom {
			height: 36px;
			line-height: 36px;
			display: flex;
			flex-wrap: nowrap;
			flex-direction: row;
			align-items: center;
			justify-content: normal;
			margin-top: 15px;
			padding: 0 12px;

			.logo {
				width: 20px;
				height: 20px;
				margin-right: 4px;
				transform: translateY(-2px);
			}

			.span1 {
				color: #f7931a;
				margin-right: 20px;
			}

			.span2 {
				margin-right: auto;
			}

			.but {
				min-width: 100px;
				height: 36px;
				text-align: center;
				border-radius: 100px;
				background: #00f0ff;
				color: #000;
				cursor: pointer;
				font-size: 14px;
			}
		}

		.middle {
			display: flex;

			.column {
				flex: 1;

				.area {
					display: flex;
					flex-wrap: nowrap;
					flex-direction: row;
					align-items: normal;
					justify-content: space-between;
					padding: 0 10px;
					margin-top: 10px;

					span:first-of-type {
						font-size: 12px;
						color: #adadad;
					}

					.win {
						color: #00f0ff;
						padding: 0 5px;
					}
				}
			}

			.bl {
				position: relative;

				&:before {
					content: "";
					position: absolute;
					height: 52px;
					width: 1px;
					border-left: 1px dashed #373739;
					top: 50%;
					left: 0;
					transform: translateY(-50%);
				}
			}
		}

		.top {
			.top-row {
				height: 30px;
				line-height: 30px;
				padding: 0 12px;
				display: flex;
				align-items: normal;
				justify-content: normal;

				img {
					width: 30px;
					height: 30px;
					border-radius: 50%;

					&:not(:first-child) {
						margin-left: -10px;
					}
				}

				.name {
					margin-left: 5px;
					margin-right: auto;
				}

				.title {
					color: #adadad;
				}
			}

			.dsddad {
				width: 100%;
			}
		}
	}
}
</style>